// Add Feed edits expose feed fields only. Omit the hidden daily fields rather
// than sending their form defaults: update_daily_report leaves omitted keys
// untouched, including NULL checks that were never answered by the operator.
const ADD_FEED_HIDDEN_FIELDS = {
  poultry: ['grit_lbs', 'mortality_count', 'mortality_reason', 'group_moved', 'waterer_checked', 'comments'],
  layer: [
    'grit_lbs',
    'layer_count',
    'mortality_count',
    'mortality_reason',
    'group_moved',
    'waterer_checked',
    'comments',
  ],
  cattle: ['fence_voltage', 'water_checked', 'mortality_count', 'mortality_reason', 'issues'],
} as const;

type DailyDomain = keyof typeof ADD_FEED_HIDDEN_FIELDS;
type HiddenField<D extends DailyDomain> = (typeof ADD_FEED_HIDDEN_FIELDS)[D][number];

export function dailyReportEditPatch<D extends DailyDomain, T extends Record<string, unknown>>(
  domain: D,
  source: string | null | undefined,
  patch: T,
): Omit<T, HiddenField<D>> & Partial<Pick<T, Extract<keyof T, HiddenField<D>>>> {
  if (source !== 'add_feed_webform') return patch;
  const editable = {...patch};
  for (const field of ADD_FEED_HIDDEN_FIELDS[domain]) Reflect.deleteProperty(editable, field);
  return editable;
}
